module.exports = __webpack_public_path__ + "media/images/pc/brands/eight/main-visual-text-b032135f8bf1328e3ad4be0a56b5d929.svg";